import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { bagSlugOf, bagsOf } from "@/lib/mall";

const CartContext = createContext(null);
const KEY = "thirteenav_cart";

export function CartProvider({ children }) {
    const [items, setItems] = useState(() => {
        try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
    });
    const [open, setOpen] = useState(false);

    useEffect(() => {
        localStorage.setItem(KEY, JSON.stringify(items));
    }, [items]);

    const addItem = (item) => {
        const withId = { ...item, id: crypto.randomUUID() };
        setItems((prev) => [...prev, withId]);
        return withId;
    };
    const removeItem = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
    const clear = () => setItems([]);
    /** You paid one shop — their bag leaves the counter, the others stay. */
    const clearStore = (slug) => setItems((prev) => prev.filter((i) => bagSlugOf(i) !== slug));

    const bags = useMemo(() => bagsOf(items), [items]);
    const count = items.length;   // lines, not pieces — "Cart (2)" means two jobs, not 250 business cards
    const subtotal = items.reduce((s, i) => s + (i.line_total || 0), 0);

    return (
        <CartContext.Provider value={{ items, bags, addItem, removeItem, clear, clearStore, count, subtotal, open, setOpen }}>
            {children}
        </CartContext.Provider>
    );
}

export const useCart = () => useContext(CartContext);
